import React, { ReactElement, Dispatch, SetStateAction } from 'react';

import COLORS from '~/constants/colors';
import { stopEventEffects } from '~/utils';

interface ShowPromoProps {
  label: string;
  setVisible: Dispatch<SetStateAction<boolean>>;
  promoText?: string;
  promoLink?: string;
}

function ShowPromo({
  label,
  setVisible,
  promoText,
  promoLink,
}: ShowPromoProps): ReactElement {
  const handleClick = (event) => {
    stopEventEffects(event);
    setVisible(true);
  };

  // Styling
  const showPromoStyle = {
    display: 'inline-block',
    width: '1.5em',
    margin: '0 0.25em 0 0',
    padding: '0.3em 0.1em',
    textAlign: 'center' as const,
    backgroundColor: COLORS.white,
    borderRadius: '0.3em',
    boxShadow: `-0.1em 0.1em ${COLORS.black25}`,
    fontSize: '1.25em',
    cursor: 'pointer',
  };
  const placeholderStyle = {
    display: 'inline-block',
    width: '1.5em',
    margin: '0 0.25em 0 0',
    padding: '0.3em 0.1em',
    fontSize: '1.25em',
  };

  return promoText || promoLink ? (
    <p
      role="none"
      style={showPromoStyle}
      onClick={handleClick}
      onTouchEnd={handleClick}
    >
      {label}
    </p>
  ) : (
    <div style={placeholderStyle} />
  );
}

export default ShowPromo;
